export const subtitle = {
  h1: {
    size: 4,
    lineHeight: 4,
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  h2: {
    size: 3,
    lineHeight: 3,
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  h3: {
    size: 2,
    lineHeight: 2,
    fontStyle: 'italic',
    fontWeight: 300
  },
  h4: {
    size: 1.875,
    lineHeight: 1,
    fontStyle: 'normal',
    fontWeight: 800
  },
  h5: {
    size: 3,
    lineHeight: 3.2,
    fontStyle: 'normal',
    fontWeight: 300
  },
  h6: {
    size: 1.875,
    lineHeight: 1,
    fontStyle: 'italic',
    fontWeight: 300
  },
  card: {
    size: 1.8,
    lineHeight: 2.4,
    fontStyle: 'normal',
    fontWeight: 300
  },
  quality: {
    size: 2.4,
    lineHeight: 3,
    fontStyle: 'normal',
    fontWeight: 300
  },
  searchItem: {
    size: 4.5,
    lineHeight: 5,
    fontStyle: 'normal',
    fontWeight: 500
  },
  mapInfo: {
    size: 3,
    lineHeight: 3.4,
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  bussOffers: {
    size: 2.2,
    lineHeight: 2.4,
    fontStyle: 'normal',
    fontWeight: 'bold'
  }
};
